import {useState} from "react";
import {HourModel} from "../models/Hour.model";
import {nextDayDate} from "../../../shared/utils/dateUtils";


export default function useHoursCalendar(employees: any[] | undefined,) {
    const [hours, setHours] = useState<HourModel[]>([])
    const [savedWeek, setSavedWeek] = useState<boolean>()
    const events: any[] = hours.reduce((acc: any[], evDay) => {
        const employee: any = employees?.find((u) => u.idDocument === evDay.idEmployee);
        const newData = employee ? (evDay.listUpdate || evDay.list).map((ev, index) => {
            const isMidnight = ev.end.hour === 0 && ev.end.minute === 0;
            const end = new Date(evDay.year, evDay.month, evDay.day, ev.end.hour, ev.end.minute)
            return {
                id: evDay.idDocument + index,
                title: employee.name,
                extendedProps: {
                    type: ev.type,
                    idEmployee: evDay.idEmployee,
                    idPharmacy: evDay.idPharmacy,
                    idPharmacist: evDay.idPharmacist,
                    idDocument: evDay.idDocument,
                    edit: !!evDay.listUpdate,
                    index,
                },
                start: new Date(evDay.year, evDay.month, evDay.day, ev.start.hour, ev.start.minute),
                end: isMidnight? nextDayDate(end) : end,
                color: employee.color,

            }
        } ) : []
        return [...acc, ...newData]
    }, [])
    return {
        hours, setHours, savedWeek, setSavedWeek, events
    };
}
